import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  transform(value: Date | string): string {
    if (!value) return '';

    // Formatear la fecha utilizando DatePipe (nativo de Angular)
    const datePipe = new DatePipe('en-US');
    const formattedDate = datePipe.transform(value, 'dd/MM/yyyy HH:mm a') || '';

    // Reemplazar 'AM' y 'PM' por 'a.m.' y 'p.m.'
    return formattedDate.replace('AM', 'a.m.').replace('PM', 'p.m.');
  }
}
